module.exports = __webpack_public_path__ + "img/send-message_red.ef4f7b29.svg";